module.exports = __webpack_public_path__ + "static/media/CNews6.9d84ad53.png";